"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseWordsArray = exports.parseTopicsArray = exports.parseKeywordsArray = exports.parseClassifiersArray = exports.b64toBlob = exports.addSpeakersToSpeakerArray = void 0;

var _Common = require("../../common/Common");

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Adds a bunch of newSpeakersNames to the given speakersArray
// if they don't exist already.
var addSpeakersToSpeakerArray = function addSpeakersToSpeakerArray(speakersArray, newSpeakersNames) {
  newSpeakersNames.forEach(function (name) {
    if (!speakersArray.map(function (s) {
      return s.toLowerCase();
    }).includes(name.toLowerCase())) {
      speakersArray.push(name);
    }
  });
  return speakersArray;
};

exports.addSpeakersToSpeakerArray = addSpeakersToSpeakerArray;

var parseKeywordsArray = function parseKeywordsArray(keywordsArray) {
  var speakers = [];
  var keywords = keywordsArray.map(function (keyword) {
    speakers = addSpeakersToSpeakerArray(speakers, Object.keys(keyword.t)); // Hmmm... This looks totally wrong, but not sure what we're meant to be doing
    // will need to come back and check as it looks like we're overwriting the
    // times property when a new one is found.

    var times = {};
    Object.keys(keyword.t).forEach(function (speakerName) {
      times[speakerName.toLowerCase()] = keyword.t[speakerName];
    });
    return _extends({}, keyword, {
      t: times,
      score: +keyword.score
    });
  });
  return {
    keywords: keywords,
    speakers: speakers
  };
};

exports.parseKeywordsArray = parseKeywordsArray;

var parseTopicsArray = function parseTopicsArray(topicsArray) {
  var speakers = [];
  var topics = topicsArray.map(function (topic) {
    var _parseKeywordsArray = parseKeywordsArray(topic.keywords),
        keywords = _parseKeywordsArray.keywords,
        keywordSpeakers = _parseKeywordsArray.speakers;

    speakers = addSpeakersToSpeakerArray(speakers, keywordSpeakers);
    return _extends({}, topic, {
      score: +topic.score,
      keywords: keywords
    });
  });
  return {
    topics: topics,
    speakers: speakers
  };
};

exports.parseTopicsArray = parseTopicsArray;

var parseWordsArray = function parseWordsArray(wordArray) {
  var transcriptSpeakers = [];
  var speakers = [];
  var words = wordArray.map(function (word) {
    if (word.m && word.m === 'turn') {
      var speakerName = (0, _Common.getClearWordFromTranscript)(word.w);
      speakers = addSpeakersToSpeakerArray(speakers, [speakerName]);
      transcriptSpeakers.push({
        start: word.s,
        name: speakerName.toLowerCase()
      });
    }

    return _extends({}, word);
  });
  return {
    words: words,
    speakers: speakers,
    transcriptSpeakers: transcriptSpeakers
  };
};

exports.parseWordsArray = parseWordsArray;

var parseClassifiersArray = function parseClassifiersArray(classifiers) {
  return (// eg: {
    //   "classifierId":"cc3ab1b0-640c-4928-85a0-1c8ff47447d7",
    //   "classifierName":"No_answer",
    //   "classifierDisplayName":"No_answer",
    //   "classifierType":"binary",
    //   "predictedClassLabel":"Call_Answered",
    //   "predictionScore":0.0018164473968978526,
    //   "predictedClass":0
    // }
    classifiers.map(function (classifier) {
      return {
        id: classifier.classifierId,
        name: classifier.classifierDisplayName || classifier.classifierName || classifier.classifierId,
        type: classifier.classifierType,
        version: classifier.classifierVersion,
        label: classifier.predictedClassLabel,
        "class": parseInt(classifier.predictedClass, 10)
      };
    })
  );
};

exports.parseClassifiersArray = parseClassifiersArray;

var b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
  if (contentType === void 0) {
    contentType = '';
  }

  if (sliceSize === void 0) {
    sliceSize = 512;
  }

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
};

exports.b64toBlob = b64toBlob;